module.exports = __webpack_public_path__ + "static/media/wallet-top-icon.d12fe8b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wallet/wallet-top-icon.png
// module id = 2142
// module chunks = 6